<template>
  <div id="member-subscription-checkout">
    <v-card class="modern-header slide-up-animation" elevation="2">
      <v-card-title class="modern-card-title pa-0">
        <!-- Floating Bubbles Background -->
        <ul class="bg-bubbles">
          <li v-for="n in 10" :key="n"></li>
        </ul>
        <div class="header-left">
          <v-icon class="mr-4 flying-icon" size="48" color="#3b82f6"
            >mdi-cart-check</v-icon
          >
          <div class="title-content">
            <h1 class="page-title">Payment Checkout</h1>
            <p class="page-subtitle">
              Review your order and complete the payment
            </p>
          </div>
        </div>
        <v-spacer />
        <div class="header-actions">
          <v-btn
            @click.prevent="backPage"
            icon
            color="#3b82f6"
            class="action-btn text-white"
            v-tooltip="'Go Back'"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-container class="notes modern-notes" v-if="!StartupLoadingFlag">
          <v-icon class="mr-2" small color="#FF6B6B"
            >mdi-information-outline</v-icon
          >
          <span class="notes-title">Important:</span>
          <span class="notes-content"
            >Please verify all details carefully before proceeding with the
            payment. Once submitted, this transaction cannot be cancelled.</span
          >
        </v-container>
        <br />
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>

        <v-container v-if="StartupLoadingFlag">
          <v-row wrap>
            <v-col cols="12" md="4" v-for="n in 6" :key="n">
              <v-skeleton-loader
                v-bind="attrs"
                type="paragraph"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>

        <v-container v-if="!StartupLoadingFlag">
          <v-form ref="form2" v-model="valid1" lazy-validation>
            <v-card
              class="form-section form-section-org slide-up-animation delay-100"
              elevation="1"
            >
              <div class="card-bubbles-container">
                <div class="card-bubble" v-for="n in 5" :key="n"></div>
              </div>
              <v-card-title class="section-title">
                <v-icon class="section-icon-wrapper" color="#3b82f6"
                  >mdi-account-circle</v-icon
                >
                LO Information
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row wrap>
                  <v-col cols="12" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span>Year
                    </label>
                    <h4 class="info-text">{{ JciYearName }}</h4>
                  </v-col>
                  <v-col cols="12" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span>LO
                    </label>
                    <h4 class="info-text">{{ Member.LomName }}</h4>
                    <h5 class="info-subtext">{{ Member.ZoneName }}</h5>
                  </v-col>
                  <v-col cols="12" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span>President Name
                    </label>
                    <h4 class="info-text">{{ Member.MemberName }}</h4>
                    <h5 class="info-subtext">{{ Member.MembershipId }}</h5>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    class="d-flex justify-center align-center"
                  >
                    <v-img
                      :src="Member.MemberImagePath"
                      :alt="Member.MemberName"
                      lazy-src="/no-image-available.png"
                      max-width="120"
                      max-height="120"
                      class="member-image float-animation"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
                <v-row wrap class="mt-4">
                  <v-col cols="12" sm="6" md="4">
                    <label class="field-label">
                      <span class="text-danger">*</span>Mobile Number
                    </label>
                    <h4 class="info-text">
                      <v-icon small class="mr-2">mdi-phone</v-icon
                      >{{ Member.PrimaryMobile }}
                    </h4>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label class="field-label">
                      <span class="text-danger">*</span>Email Id
                    </label>
                    <h4 class="info-text">
                      <v-icon small class="mr-2">mdi-email</v-icon
                      >{{ Member.EmailId }}
                    </h4>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="field-label">
                      <span class="text-danger">*</span>GST Number
                    </label>
                    <h4 class="info-text">
                      <v-icon small class="mr-2">mdi-file-document</v-icon
                      >{{ GstNumber }}
                    </h4>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-container class="py-0 mt-6" v-if="SearchFlag">
              <v-skeleton-loader
                v-bind="attrs"
                type="table-tbody"
              ></v-skeleton-loader>
            </v-container>

            <v-container class="py-0 mt-6" v-if="!SearchFlag">
              <v-card
                class="form-section form-section-payment slide-up-animation delay-200"
                elevation="1"
              >
                <div class="card-bubbles-container">
                  <div class="card-bubble" v-for="n in 5" :key="n"></div>
                </div>
                <v-card-title class="section-title">
                  <v-icon class="section-icon-wrapper" color="#3b82f6"
                    >mdi-receipt-text</v-icon
                  >
                  Order Summary
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-6">
                  <v-row wrap>
                    <v-col align="center" cols="12" md="12">
                      <v-data-table
                        class="modern-table elevation-2"
                        disable-sort
                        disable-filtering
                        v-model="selected"
                        :loading="SearchFlag"
                        loading-text="Loading... Please wait"
                        :headers="tableColumns1"
                        :items="rows"
                        :items-per-page="50"
                        :search="search"
                        item-key="YearwiseContributionId"
                        :single-select="false"
                        :show-select="false"
                        :hide-default-footer="true"
                        :footer-props="{
                          'items-per-page-options': [10, 20, 30, 40, 50],
                        }"
                      >
                        <template v-slot:[`item.Qty`]="{ item }">
                          <span class="qty-badge">{{ item.Qty }}</span>
                        </template>
                        <template v-slot:[`item.SubTotal`]="{ item }">
                          <span class="amount-text">{{ item.SubTotal }}</span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-row class="mt-6">
                <v-col align="center" cols="12" md="12">
                  <div class="total-amount slide-up-animation delay-300">
                    <v-icon size="32">mdi-cash-multiple</v-icon>
                    <span class="amount-label">Total Amount:</span>
                    <span class="amount-value">₹ {{ TotalAmount }}</span>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="backPage"
                    elevation="4"
                    x-large
                    rounded
                    class="submit-btn btn-gradient-danger px-12 mr-4 text-white"
                  >
                    <v-icon left size="24">mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="confirmAlert"
                    :loading="SubmitFlag"
                    elevation="4"
                    x-large
                    rounded
                    class="submit-btn btn-gradient-success px-12 text-white"
                  >
                    <v-icon left size="24">mdi-credit-card</v-icon>
                    Pay Now
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-container>
        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      rows: [],
      tableColumns1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      TotalAmount: 0,

      PaymentGateway: "",
      Member: {},
      OrderConfig: {},
      ThemeConfig: {},
      MemberImageFlag: false,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      JciYearName: "",

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: 11,
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [(v) => !!v || "Email Id No is required"],

      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v >= 0 || "Number must be greater than zero",
      ],

      LomName: "",
      LomNameRules: [(v) => !!v || "LOM name is required"],

      GstNumber: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    backPage() {
      console.log("backPage called");
      var url = "/members/subscription/payment/create";
      var params = {};
      this.pageRedirect(params, url);
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/staff/list";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.$refs.form2.reset();
      this.CharterDate = "";
      this.AffiliationDate = "";
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var checkout = this.$session.get("checkout");
      checkout = checkout == (null || undefined) ? {} : checkout;
      console.log({ checkout });
      this.PaymentGateway = checkout.PaymentGateway;
      this.JciYearCode = checkout.YearCode;
      this.JciYearName = checkout.YearName;
      this.GstNumber =
        checkout.GstNumber != "" && checkout.GstNumberFlag == 1
          ? checkout.GstNumber
          : "NA";
      this.Member = checkout.Member;
      this.TotalAmount = checkout.TotalAmount;
      this.OrderConfig = checkout.Order;
      this.ThemeConfig = checkout.Theme;
      this.tableColumns1 = checkout.TableHeaders;
      var Contribution = checkout.Contribution;
      this.rows = Contribution;
    },
    billdeskPayment() {
      console.log("billdeskPayment called");
      const thisIns = this;
      var responseHandler = function (txn) {
        console.log({ txn });

        var response = txn.txnResponse;
        console.log({ response });

        var message = response.hasOwnProperty("message")
          ? response.message
          : "";
        console.log({ message });

        var transactionResponse = response.hasOwnProperty(
          "transaction_response"
        )
          ? response.transaction_response
          : "";
        console.log({ transactionResponse });

        if (transactionResponse != "") {
          thisIns.$session.remove("checkout");
          thisIns.SubmitFlag = true;
          thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/payment/success");
        } else {
          thisIns.sweetAlert("error", message, true);
          thisIns.pageRedirect({}, "/members/subscription/payment/create");
        }
      };

      var config = {
        responseHandler: responseHandler,
        // merchantLogo: "data:image/png;base64:eqwewqesddhgjdxsc==",
        flowConfig: this.OrderConfig,
        flowType: "payments",
        themeConfig: this.ThemeConfig,
      };

      window.loadBillDeskSdk(config);
    },
    razorpayPayment() {
      console.log("razorpayPayment");
      // ev.preventDefault();
      var order = this.OrderConfig;
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        // callback_url: "http://domain.com/#/about/" + this.order_id,
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.$session.remove("checkout");
          thisIns.SubmitFlag = true;
          thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/payment/success");
        },
      });
      rzp1.open();
    },
    confirmAlert() {
      var validate1 = this.$refs.form2.validate();
      var TotalAmount = this.TotalAmount;
      console.log("validate1=" + validate1 + ", TotalAmount=" + TotalAmount);

      var PaymentGateway = this.PaymentGateway;
      console.log({ PaymentGateway });

      // TotalAmount=0;

      if (validate1 && TotalAmount > 0) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            if (PaymentGateway == 1) {
              this.razorpayPayment();
            } else {
              this.billdeskPayment();
            }
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Minimum one nos required to continue. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 1;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
    this.CurrentYearId = CurrentYearId;
    if (this.$session.has("checkout")) {
      /*
      this.tableColumns1.push(
        { text: "Description", value: "Description" },
        { text: "Subscription Fees", value: "AmountTxt" },
        { text: "Nos", value: "Qty" },
        { text: "Sub Total", value: "SubTotal" }
        // { text: "Actions", value: "actions" }
      );
      */
      this.refreshPageData();
    } else {
      this.$router.push("/access-denied");
    }
  },
};
</script>
<style lang="scss">
/* Professional Checkout Page Styles */

#member-subscription-checkout {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
  padding: 24px 16px;

  // --- Modern Header ---
  .modern-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fc 100%);
    border: 2px solid #e2e8f0;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    margin-bottom: 32px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }

  .modern-card-title {
    padding: 36px 42px !important;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  // --- Animated Bubbles Background ---
  .bg-bubbles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    overflow: hidden;
    margin: 0;
    padding: 0;

    li {
      position: absolute;
      list-style: none;
      display: block;
      width: 40px;
      height: 40px;
      background: rgba(59, 130, 246, 0.05);
      backdrop-filter: blur(2px);
      bottom: -160px;
      animation: square 25s infinite;
      transition-timing-function: linear;
      border-radius: 50%;

      @for $i from 1 through 10 {
        &:nth-child(#{$i}) {
          left: #{$i * 10%};
          width: #{random(100) + 20}px;
          height: #{random(100) + 20}px;
          animation-delay: #{$i * 2}s;
          animation-duration: #{random(20) + 20}s;
        }
      }
    }
  }

  @keyframes square {
    0% {
      transform: translateY(0) rotate(0deg);
      opacity: 1;
    }
    100% {
      transform: translateY(-1000px) rotate(720deg);
      opacity: 0;
    }
  }

  // --- Header Elements ---
  .header-left {
    display: flex;
    align-items: center;
    z-index: 2;
  }

  .flying-icon {
    animation: float 3s ease-in-out infinite;
    filter: drop-shadow(0 2px 8px rgba(59, 130, 246, 0.3));
    color: #3b82f6 !important;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-15px);
    }
  }

  .title-content {
    .page-title {
      font-size: 36px;
      font-weight: 800;
      color: #1e293b;
      margin: 0;
      line-height: 1.2;
      letter-spacing: -0.5px;
      text-shadow: none;
    }

    .page-subtitle {
      font-size: 16px;
      color: #64748b;
      margin: 6px 0 0 0;
      font-weight: 500;
      letter-spacing: 0.3px;
    }
  }

  .header-actions {
    z-index: 2;

    .action-btn {
      background: #3b82f6;
      backdrop-filter: blur(10px);
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);

      &:hover {
        background: #2563eb;
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35);
      }
    }
  }

  // --- Animations ---
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .slide-up-animation {
    animation: slideUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    opacity: 0;
  }

  .delay-100 {
    animation-delay: 0.1s;
  }

  .delay-200 {
    animation-delay: 0.2s;
  }

  .delay-300 {
    animation-delay: 0.3s;
  }

  // --- Form Sections ---
  .form-section {
    border-radius: 18px;
    background: #ffffff;
    position: relative;
    overflow: hidden;
    margin-bottom: 28px;
    border: 2px solid rgba(48, 43, 99, 0.1);
    box-shadow: 0 10px 30px rgba(15, 12, 41, 0.08);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 15px 40px rgba(15, 12, 41, 0.12);
      transform: translateY(-2px);
      border-color: rgba(48, 43, 99, 0.15);
    }
  }

  .card-bubbles-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;
    pointer-events: none;

    .card-bubble {
      position: absolute;
      border-radius: 50%;
      background: radial-gradient(
        circle,
        rgba(48, 43, 99, 0.03) 0%,
        rgba(48, 43, 99, 0.01) 70%,
        transparent 100%
      );

      &:nth-child(1) {
        width: 200px;
        height: 200px;
        top: -80px;
        left: -60px;
      }

      &:nth-child(2) {
        width: 150px;
        height: 150px;
        top: 30%;
        right: -50px;
      }

      &:nth-child(3) {
        width: 100px;
        height: 100px;
        bottom: -30px;
        left: 20%;
      }

      &:nth-child(4) {
        width: 180px;
        height: 180px;
        bottom: -70px;
        right: 15%;
      }

      &:nth-child(5) {
        width: 120px;
        height: 120px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .section-title {
    font-size: 20px;
    font-weight: 800;
    color: #1a1a2e;
    padding: 24px 28px 20px !important;
    position: relative;
    z-index: 1;
    letter-spacing: -0.3px;
    background: linear-gradient(to right, rgba(48, 43, 99, 0.03), transparent);

    .section-icon-wrapper {
      background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
      color: #ffffff !important;
      padding: 12px;
      border-radius: 14px;
      margin-right: 16px;
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
    }
  }

  // --- Field Labels ---
  .field-label {
    font-size: 11px;
    font-weight: 800;
    color: #4a5568;
    margin-bottom: 8px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 1px;

    .text-danger {
      color: #e53e3e;
      margin-right: 3px;
      font-size: 13px;
    }
  }

  .info-text {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    margin: 6px 0 4px 0;
    line-height: 1.5;
    display: flex;
    align-items: center;

    .v-icon {
      color: #3b82f6 !important;
    }
  }

  .info-subtext {
    font-size: 13px;
    font-weight: 600;
    color: #718096;
    margin: 0;
  }

  // --- Member Image ---
  .member-image {
    border-radius: 16px;
    border: 4px solid #3b82f6;
    box-shadow: 0 8px 24px rgba(59, 130, 246, 0.25);
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 12px 32px rgba(59, 130, 246, 0.35);
    }
  }

  @keyframes floating {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  .float-animation {
    animation: floating 3s ease-in-out infinite;
  }

  // --- Modern Table ---
  .modern-table {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(15, 12, 41, 0.1);
    border: 1px solid rgba(48, 43, 99, 0.1);

    ::v-deep .v-data-table__wrapper {
      border-radius: 16px;

      table {
        thead {
          tr {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

            th {
              color: #ffffff !important;
              font-weight: 700 !important;
              font-size: 13px !important;
              text-transform: uppercase;
              letter-spacing: 1px;
              padding: 20px 24px !important;
              border: none !important;
            }
          }
        }

        tbody {
          background: #ffffff;

          tr {
            transition: all 0.3s ease;

            &:hover {
              background: linear-gradient(to right, rgba(59, 130, 246, 0.04), transparent) !important;
              transform: translateX(2px);
            }

            td {
              font-size: 14px !important;
              padding: 18px 24px !important;
              color: #1a1a2e;
              font-weight: 600;
              border-bottom: 1px solid rgba(48, 43, 99, 0.08) !important;
            }
          }
        }
      }
    }
  }

  .qty-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: #ffffff;
    font-weight: 700;
    font-size: 15px;
    padding: 8px 20px;
    border-radius: 30px;
    min-width: 50px;
    box-shadow: 0 3px 10px rgba(59, 130, 246, 0.25);
  }

  .amount-text {
    font-weight: 800;
    color: #1a1a3e;
    font-family: "IBM Plex Mono", "Roboto Mono", monospace;
    font-size: 15px;
    background: rgba(48, 43, 99, 0.05);
    padding: 6px 10px;
    border-radius: 6px;
    letter-spacing: 0.3px;
  }

  // --- Total Amount ---
  .total-amount {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    padding: 28px 48px;
    background: linear-gradient(
      135deg,
      rgba(59, 130, 246, 0.08),
      rgba(59, 130, 246, 0.04)
    );
    border: 3px solid rgba(59, 130, 246, 0.2);
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.1);

    .v-icon {
      color: #3b82f6;
      font-size: 36px !important;
    }

    .amount-label {
      font-size: 18px;
      font-weight: 700;
      color: #475569;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .amount-value {
      font-size: 36px;
      font-weight: 900;
      color: #1e40af;
      font-family: "IBM Plex Mono", "Roboto Mono", monospace;
      letter-spacing: 1px;
    }
  }

  // --- Submit Buttons ---
  .submit-btn {
    font-weight: 800;
    letter-spacing: 1px;
    text-transform: uppercase;
    min-width: 200px;
    height: 56px !important;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(48, 43, 99, 0.25);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    animation: pulse-glow 3s infinite;

    &:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: 0 16px 36px rgba(48, 43, 99, 0.35);
    }

    &:disabled {
      box-shadow: none;
      animation: none;
      opacity: 0.7;
      background: #cbd5e0 !important;
      color: #718096 !important;
    }
  }

  @keyframes pulse-glow {
    0% {
      box-shadow: 0 8px 20px rgba(48, 43, 99, 0.25);
    }
    70% {
      box-shadow: 0 8px 20px rgba(48, 43, 99, 0.4);
    }
    100% {
      box-shadow: 0 8px 20px rgba(48, 43, 99, 0.25);
    }
  }

  .btn-gradient-success {
    background: linear-gradient(135deg, #00b09b 0%, #016e62 100%) !important;
  }

  .btn-gradient-danger {
    background: linear-gradient(135deg, #ff6b6b 0%, #fd3838 100%) !important;
  }

  // --- Notes ---
  .modern-notes {
    background: linear-gradient(
      to right,
      rgba(229, 62, 62, 0.08),
      rgba(229, 62, 62, 0.04)
    );
    backdrop-filter: blur(5px);
    border: 2px solid rgba(229, 62, 62, 0.25);
    border-left: 6px solid #e53e3e;
    border-radius: 14px;
    padding: 20px 28px;
    margin-bottom: 28px;
    box-shadow: 0 6px 20px rgba(229, 62, 62, 0.12);

    .notes-title {
      font-weight: 900;
      color: #c53030;
      font-size: 13px;
      margin-right: 8px;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .notes-content {
      font-weight: 600;
      color: #2d3748;
      font-size: 14px;
      line-height: 1.6;
    }

    .v-icon {
      color: #e53e3e !important;
      font-size: 20px !important;
    }
  }

  // --- Responsive Design ---
  @media (max-width: 960px) {
    padding: 16px 12px;

    .modern-card-title {
      flex-direction: column;
      align-items: flex-start !important;
      padding: 28px 24px !important;

      .header-left {
        margin-bottom: 16px;

        .flying-icon {
          font-size: 40px !important;
          margin-right: 16px !important;
        }

        .title-content .page-title {
          font-size: 28px;
        }

        .title-content .page-subtitle {
          font-size: 14px;
        }
      }

      .header-actions {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }

    .total-amount {
      flex-direction: column;
      gap: 12px;
      padding: 20px 24px;

      .amount-value {
        font-size: 28px;
      }
    }

    .submit-btn {
      width: 100%;
      min-width: unset;
      margin-bottom: 12px;
    }
  }

  @media (max-width: 600px) {
    padding: 12px 8px;

    .modern-card-title {
      padding: 20px 16px !important;

      .header-left {
        .flying-icon {
          font-size: 36px !important;
        }

        .title-content .page-title {
          font-size: 24px;
        }

        .title-content .page-subtitle {
          font-size: 13px;
        }
      }
    }

    .section-title {
      font-size: 18px;
      padding: 18px 20px 16px !important;

      .section-icon-wrapper {
        padding: 8px;
        margin-right: 12px;
      }
    }

    .modern-table ::v-deep .v-data-table__wrapper table {
      thead tr th {
        font-size: 12px !important;
        padding: 14px 16px !important;
      }

      tbody tr td {
        font-size: 13px !important;
        padding: 14px 16px !important;
      }
    }

    .total-amount {
      padding: 16px 20px;

      .amount-label {
        font-size: 16px;
      }

      .amount-value {
        font-size: 24px;
      }
    }
  }
}
</style>